// State machine for app navigation. Primarily this just handles the page stack.

import Home from '@/views/Home.vue';
import Subscriptions from '@/views/Subscriptions.vue';
import Downloads from '@/views/Downloads.vue';
import Account from '@/views/Account.vue';
import Splash from '@/views/Splash.vue';

export default {
  strict: true,
  namespaced: true,
  state: {
    stack: [Splash],
    options: {},
    initialized: false,
    isHardwareNavigation: true,
    mainTabs: [
      {
        label: 'home',
        icon: 'pc-home',
        'active-icon': 'pc-home',
        page: Home,
        autogrow: true,
      },
      {
        label: 'subscriptions',
        icon: 'pc-subscriptions',
        // 'active-icon': 'pc-subscriptions',
        page: Subscriptions,
        badge: null,
        autogrow: true,
      },
      {
        label: 'downloads',
        icon: 'pc-downloads',
        'active-icon': 'pc-downloads',
        class: 'notification-secondary',
        page: Downloads,
        badge: null,
        autogrow: true,
      },
      {
        label: 'account',
        icon: 'pc-user',
        'active-icon': 'pc-user',
        page: Account,
        autogrow: true,
      },
    ],
  },
  mutations: {
    push(state, page) { // push a single page to the stack
      state.stack.push(page);
    },
    pop(state, steps = 1) { // remove the page on top of the stack
      if (state.stack.length > 1) {
        if (steps === 1) {
          state.stack.pop();
        } else {
          state.stack.splice(-steps, steps);
        }
      }
    },
    replace(state, page) { // remove the page on top and push a single page
      state.stack.pop();
      state.stack.push(page);
    },
    reset(state, page) { // remove all pages in the stack and push a single page
      state.stack = [page || state.stack[0]];
    },
    setInitialized(state) {
      state.initialized = true;
    },
    setIsHardwareNavigation(state, isHardwareNavigation) {
      state.isHardwareNavigation = isHardwareNavigation;
    },
    setSubscriptionsTabBadge(state, badge) {
      // state.mainTabs[1] = {
      //   label: 'subscriptions',
      //   icon: 'pc-subscriptions',
      //   page: Subscriptions,
      //   badge: badge,
      //   autogrow: true,
      // };
      state.mainTabs[1].badge = badge;
      // state.mainTabs[1].icon = null;
      // state.mainTabs[1].icon = 'pc-subscriptions';
    },
    setDownloadsTabBadge(state, badge) {
      state.mainTabs[2].badge = badge;
    },
  },
};
